import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { Avatar, Box, Button, styled, Typography } from "@mui/material";
import avr1 from "../images/avr1.png";
import avr2 from "../images/avr2.png";
import avr3 from "../images/avr3.png";
import avr4 from "../images/avr4.png";
import avr5 from "../images/avr5.png";
import avr6 from "../images/avr6.png";
import avr7 from "../images/avr7.png";
import avr8 from "../images/avr8.png";
import avr9 from "../images/avr9.png";
import avr10 from "../images/avr10.png";
import axios from "axios";
import { API_URL } from "../components/Constant";
import cr1 from "../images/cr1.png";
import cr2 from "../images/cr2.png";
import cr3 from "../images/cr3.png";
import cr4 from "../images/cr4.png";
import cr5 from "../images/cr5.png";
import cr6 from "../images/cr6.png";
import cr7 from "../images/cr7.png";
import cr8 from "../images/cr8.png";
import cr9 from "../images/cr9.png";
import cr10 from "../images/cr10.png";
import tiny from "../images/tiny.png";
import master from "../images/master.png";
import logic from "../images/logic.png";
import backtobench from "../images/backtobench.png";
import timeless from "../images/timeless.jpg";
import SnowingEffect from "../components/Snowpopup";
import { Link } from "react-router-dom";
import FloatingSocialIcons from "./SocialMedia";
import Colors from "../components/Colors";
import SliderRapidRiddle from "../components/sliderRapidRiddle";
import Footer from "../components/Footer";
import PasswordPopup from "../components/PasswordPopup";
import ConfirmPasswordPopup from "../components/ConfirmPasswordPopUp";

function Landing() {
  const [creators, setCreators] = useState([]);
  const [creatorDetails, setCreatorDetails] = useState([]);
  const [uniqueGameIds, setUniqueGameIds] = useState([]);
  const [isCreator, setIsCreator] = useState(false);
  const [creatorId, setCreatorId] = useState(null);
  const [playedGames, setPlayedGames] = useState([]);

  const avatarMap = {
    1: avr1,
    2: avr2,
    3: avr3,
    4: avr4,
    5: avr5,
    6: avr6,
    7: avr7,
    8: avr8,
    9: avr9,
    0: avr10,
  };
  const creatorMap = {
    1: cr1,
    2: cr2,
    3: cr3,
    4: cr4,
    5: cr5,
    6: cr6,
    7: cr7,
    8: cr8,
    9: cr9,
    0: cr10,
  };

  //   useEffect(() => {

  //     const fetchGameData = async () => {
  //         try {
  //             const response = await axios.get(`${API_URL}/classify_games`);
  //             setCreators(response.data)
  //             console.log('classify_games',response.data)
  //         } catch (error) {
  //             console.error('Error fetching data:', error);

  //         }
  //     };
  //     fetchGameData();
  //     const intervalId = setInterval(fetchGameData, 1000);

  //     return () => clearInterval(intervalId);

  // }, []);

  // useEffect(() => {

  //   const fetchGameScoreData = async () => {
  //       try {
  //           const response = await axios.post(`${API_URL}/player_score`, {
  //               PlayerTocken: localStorage.getItem("PlayerTocken")
  //               });

  //           console.log('creator id',localStorage.getItem('SelectedId'))
  //           console.log('player score',response.data.result)
  //          const clickId = localStorage.getItem('SelectedId')
  //           const gameData = response.data.result
  //         //  const filteredGames = gameData.filter((game) => game.creator_id === clickId);
  //         const filteredGames = gameData.rows.filter((game) => game.creator_id === Number(clickId));
  //           setPlayedGames(filteredGames)
  //           console.log('filteredGames',filteredGames)

  //       } catch (error) {
  //           console.error('Error fetching data:', error);

  //       }
  //   };
  //   fetchGameScoreData();
  //   const intervalId = setInterval(fetchGameScoreData, 1000);

  //   return () => clearInterval(intervalId);

  // }, []);

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await axios.get(`${API_URL}/classify_games`);
        setCreators(response.data);
        localStorage.setItem("Data", response.data);
        //  console.log('classify_games', response.data)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchGameData();
    // const intervalId = setInterval(fetchGameData, 1000);

    //return () => clearInterval(intervalId);
  }, []);

  // const launchingThusharam = creators.filter(creator => creator.category === 'Tiny Thinkers');
  // const launchedHemandam = creators.filter(creator => creator.category === 'Master Minds');
  // const launchedNeeharam = creators.filter(creator => creator.category === 'Logic Legends');
  // const launchedBackToBench = creators.filter(creator => creator.category === 'Back To Bench');
  const [chunkSize, setChunkSize] = useState(3); // Default to 3 columns per row

  useEffect(() => {
    const updateChunkSize = () => {
      if (window.innerWidth <= 568) {
        setChunkSize(1); // Show 2 columns per row on mobile
      } else {
        setChunkSize(3); // Show 3 columns per row on desktop
      }
    };

    window.addEventListener("resize", updateChunkSize);
    updateChunkSize(); // Run on mount

    return () => window.removeEventListener("resize", updateChunkSize);
  }, []);

  // Filter creators by category
  // const launchingThusharam = creators.filter(creator => creator.category === 'Tiny Thinkers');
  // const launchedHemandam = creators.filter(creator => creator.category === 'Master Minds');
  // const launchedNeeharam = creators.filter(creator => creator.category === 'Logic Legends');
  const launchingThusharam = creators.filter(
    (creator) => creator.category === "Tiny Thinkers",
  );
  const launchedHemandam = creators.filter(
    (creator) => creator.category === "Master Minds",
  );
  const launchedNeeharam = creators.filter(
    (creator) => creator.category === "Logic Legends",
  );
  const launchedBackToBench = creators.filter(
    (creator) => creator.category === "Back To Bench",
  );
  const launchedTimelessTies = creators.filter(
    (creator) => creator.category === "Timeless Ties",
  );

  // Remove duplicate creators by creator_id
  const uniquelaunchingThusharam = Array.from(
    new Map(
      launchingThusharam.map((creator) => [creator.creator_id, creator]),
    ).values(),
  );
  const uniquelaunchedHemandam = Array.from(
    new Map(
      launchedHemandam.map((creator) => [creator.creator_id, creator]),
    ).values(),
  );
  const uniquelaunchedNeeharam = Array.from(
    new Map(
      launchedNeeharam.map((creator) => [creator.creator_id, creator]),
    ).values(),
  );
  const uniquelaunchedBackToBench = Array.from(
    new Map(
      launchedBackToBench.map((creator) => [creator.creator_id, creator]),
    ).values(),
  );
  const uniquelaunchedTimelessTies = Array.from(
    new Map(
      launchedTimelessTies.map((creator) => [creator.creator_id, creator]),
    ).values(),
  );

  // Function to split array into chunks of chunkSize
  const chunkArray = (arr) => {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  };

  // Group creators into rows of chunkSize
  const uniqueThusharam = chunkArray(uniquelaunchingThusharam);
  const uniqueHemandam = chunkArray(uniquelaunchedHemandam);
  const uniqueNeeharam = chunkArray(uniquelaunchedNeeharam);
  const uniqueBackToBench = chunkArray(uniquelaunchedBackToBench);
  const uniqueTimelessTies = chunkArray(uniquelaunchedTimelessTies);

  // Fetch details for a specific creator
  const handleCreatorClick = async (creatorId, status) => {
    console.log(creatorId);
    localStorage.removeItem("BackToBenchTocken");
    localStorage.removeItem("TimelessTiesTocken");
    setIsCreator(true);
    setCreatorId(creatorId);
    localStorage.setItem("selectedCreator", creatorId);
    localStorage.setItem("selectedCat", status);
    console.log(status === "Back To Bench");
    if (status === "Back To Bench" && status !== "Timeless Ties") {
      window.location.href = "/back-to-bench-signin";
    } else if (status === "Timeless Ties" && status !== "Back To Bench") {
      window.location.href = "/timeless-ties-signin";
    } else if (!localStorage.getItem("PlayerTocken")) {
      window.location.href = "/player-signin";
    } else {
      window.location.href = "/all-game";
    }
  };

  const handleGameClick = async (gameId) => {
    localStorage.setItem("gameId", gameId);
    localStorage.setItem("creatorId", creatorId);
    window.location.href = "/play-game";
  };

  function formatPublishingTime(dateString) {
    // Check if dateString is valid
    if (!dateString) {
      console.error("Invalid date string:", dateString);
      return ""; // Return an empty string or handle this case as needed
    }

    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date)) {
      console.error("Invalid date object:", date);
      return ""; // Return an empty string or handle this case as needed
    }

    const dateOnly = date.toISOString().split("T")[0];
    const today = new Date();

    // Check if the date is today
    if (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    ) {
      return "TODAY";
    }

    // Format the date to 'DD MMM YYYY' (e.g., 31 JAN 2025)
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return new Intl.DateTimeFormat("en-US", options).format(date).toUpperCase();
  }

  const isToday = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const lastShown = localStorage.getItem("passwordPopupLastShown");
  const today = new Date().toDateString();
  const [isPassword, setIsPassword] = useState(false);
  const [isConfirmPassword, setIsConfirmPassword] = useState(false);
  const [myHint, setMyHint] = useState(null);
  const [myPassword, setMyPassword] = useState(null);

  useEffect(() => {
    if (localStorage.getItem("PlayerTocken")) {
      const fetchSpData = async () => {
        try {
          const response = await axios.post(
            `${API_URL}/select_player_details_with_tocken`,
            {
              PlayerTocken: localStorage.getItem("PlayerTocken"),
            },
          );
          console.log(response.data.result.new_password);
          if (
            response.data.result.new_password === null ||
            response.data.result.new_password === ""
          ) {
            if (lastShown !== today) {
              setIsPassword(true);
              //localStorage.setItem("passwordPopupLastShown", today); // Update storage with today's date
            }
          } else {
            if (lastShown !== today) {
              setIsConfirmPassword(true);
              // localStorage.setItem("passwordPopupLastShown", today); // Update storage with today's date
            }
            setMyHint(response.data.result.hint);
            setMyPassword(response.data.result.new_password);
          }
          console.log(response.data.result.hint);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchSpData();
    }
  }, [localStorage.getItem("PlayerTocken")]);

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', width: '100%', gap: '8px',
      background: Colors.bgColor, justifyContent: 'center', alignItems: 'center', minHeight: '100vh'
    }}>
      {/* <FloatingSocialIcons></FloatingSocialIcons> 
      {isPassword && <PasswordPopup setIsPassword={setIsPassword}></PasswordPopup>}
      {isConfirmPassword && <ConfirmPasswordPopup setIsConfirmPassword={setIsConfirmPassword} 
      myHint={myHint} myPassword={myPassword}></ConfirmPasswordPopup>}*/}
      <Box sx={{ width: '100%', zIndex: 101, position: 'relative' }}>
        <Header />
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "20px",
          flexDirection: "column",
          width: "100%",
          height: { md: "100px", xs: "80px" },
          maxWidth: { xs: "92%", md: "92%" },
          justifyContent: "center",
          alignItems: "center",
          background: Colors.Tidesbg,
          borderRadius: "8px",
          overflow: "hidden",
          marginTop: { xs: "5%", md: "2.5%" },
          borderColor: "#EACABB",
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: { xs: "14px", md: "16px" },
            lineHeight: "24px",
            color: Colors.Tidesfont,
            textAlign: "center",
            fontFamily: "Roboto",
          }}
        >
          You can only earn points if you create an account. Please hurry and{" "}
          <Button
            onClick={() => {
              window.location.href = "/player-signup";
            }}
            sx={{
              background: Colors.button2,
              color: Colors.button2font,
              width: "120px",
              border: "1px solid ",
              borderColor: Colors.button2Border,
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "12px",
              boxShadow: "0 4px 10px rgba(230, 194, 170, 0.5)",
              transition: "background 0.3s, transform 0.3s",
              "&:hover": {
                background: Colors.button2,
                transform: "scale(1.05)",
              },
              "&:active": {
                background: Colors.button2,
              },
            }}
          >
            Register here
          </Button>
        </Typography>
      </Box>

      <SliderRapidRiddle />

      <Box
        sx={{
          display: "flex",
          marginTop: { md: "4%", xs: "20px" },
          marginBottom: { md: "2%", xs: "20px" },
          flexDirection: { xs: "column", md: "column" },
          width: "100%",
          justifyContent: "center",
          height: "100%",
          background: Colors.dailyPuzle,
          alignItems: "center",
          paddingBottom: { md: "0%", xs: "5%" },
        }}
      >
        <Typography
          sx={{
            color: "#000",
            fontWeight: "bold",
            fontSize: { md: "48px", xs: "24px" },
            fontFamily: "Boogaloo",
            paddingTop: { md: "0%", xs: "5%" },
          }}
        >
          Daily Puzzle
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: { md: "5%", xs: "20px" },
            maxWidth: "90%",
            maxHeight: "90%",
            paddingBottom: { md: "2.5%", xs: "5%" },
            paddingTop: { md: "0%", xs: "5%" },
            width: "100%",
            flexWrap: "wrap", // Ensures items wrap to the next line
            justifyContent: { md: "flex-start", xs: "center" }, // Centers the items
          }}
        >
          <Box sx={{ display: "flex", width: { md: "30%", xs: "90%" } }}>
            {uniqueThusharam.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  background: Colors.puzzlebg,
                  borderRadius: "8px",
                }}
              >
                {uniqueThusharam.map((chunk, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      gap: "16px",
                      width: "100%",
                      padding: "64px 32px",
                    }}
                  >
                    {chunk.map((creator) => (
                      <Box
                        key={creator.creator_id}
                        sx={{
                          position: "relative", // To position the starburst
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          borderRadius: "8px",
                          height: { md: "300px", xs: "260px" },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px 0px",
                            width: "100%",
                            borderRadius: "8px 8px 0px 0px",
                            height: "48px",
                            background: Colors.nameBg,
                          }}
                        >
                          <Typography
                            sx={{
                              color: Colors.Tidesfont,
                              fontSize: "20px",
                              fontWeight: 600,
                              fontFamily: "Roboto",
                            }}
                          >
                            Tiny Thinkers
                          </Typography>
                        </Box>

                        <img
                          alt="profile"
                          src={tiny}
                          onClick={() =>
                            handleCreatorClick(
                              creator.creator_id,
                              "Tiny Thinkers",
                            )
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                            //borderRadius: '8px',
                            objectFit: "cover",
                          }}
                        />

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px 0px",
                            width: "100%",
                            borderRadius: "0px 0px 8px 8px",
                            height: "48px",
                            background: Colors.nameBg,
                          }}
                        >
                          <Typography
                            sx={{
                              color: Colors.Tidesfont,
                              fontSize: "20px",
                              fontWeight: 400,
                              fontFamily: "Roboto",
                            }}
                          >
                            Age below 10
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}
          </Box>

          <Box sx={{ display: "flex", width: { md: "30%", xs: "90%" } }}>
            {uniqueHemandam.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  background: Colors.puzzlebg,
                  borderRadius: "8px",
                }}
              >
                {uniqueHemandam.map((chunk, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      gap: "16px",
                      width: "100%",
                      padding: "64px 32px",
                    }}
                  >
                    {chunk.map((creator) => (
                      <Box
                        key={creator.creator_id}
                        sx={{
                          position: "relative", // To position the starburst
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          borderRadius: "8px",
                          height: { md: "300px", xs: "260px" },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px 0px",
                            width: "100%",
                            borderRadius: "8px 8px 0px 0px",
                            height: "48px",
                            background: Colors.nameBg,
                          }}
                        >
                          <Typography
                            sx={{
                              color: Colors.Tidesfont,
                              fontSize: "20px",
                              fontWeight: 600,
                              fontFamily: "Roboto",
                            }}
                          >
                            Master Minds
                          </Typography>
                        </Box>

                        <img
                          alt="profile"
                          src={master}
                          onClick={() =>
                            handleCreatorClick(
                              creator.creator_id,
                              "Master Minds",
                            )
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                            //borderRadius: '8px',
                            objectFit: "cover",
                          }}
                        />

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px 0px",
                            width: "100%",
                            borderRadius: "0px 0px 8px 8px",
                            height: "48px",
                            background: Colors.nameBg,
                          }}
                        >
                          <Typography
                            sx={{
                              color: Colors.Tidesfont,
                              fontSize: "20px",
                              fontWeight: 400,
                              fontFamily: "Roboto",
                            }}
                          >
                            Age between 10 to 20
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}
          </Box>

          <Box sx={{ display: "flex", width: { md: "30%", xs: "90%" } }}>
            {uniqueNeeharam.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  background: Colors.puzzlebg,
                  borderRadius: "8px",
                }}
              >
                {uniqueNeeharam.map((chunk, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      gap: "16px",
                      width: "100%",
                      padding: "64px 32px",
                    }}
                  >
                    {chunk.map((creator) => (
                      <Box
                        key={creator.creator_id}
                        sx={{
                          position: "relative", // To position the starburst
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          borderRadius: "8px",
                          height: { md: "300px", xs: "260px" },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px 0px",
                            width: "100%",
                            borderRadius: "8px 8px 0px 0px",
                            height: "48px",
                            background: Colors.nameBg,
                          }}
                        >
                          <Typography
                            sx={{
                              color: Colors.Tidesfont,
                              fontSize: "20px",
                              fontWeight: 600,
                              fontFamily: "Roboto",
                            }}
                          >
                            Logic Legends
                          </Typography>
                        </Box>

                        <img
                          alt="profile"
                          src={logic}
                          onClick={() =>
                            handleCreatorClick(
                              creator.creator_id,
                              "Logic Legends",
                            )
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                            //borderRadius: '8px',
                            objectFit: "cover",
                          }}
                        />

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px 0px",
                            width: "100%",
                            borderRadius: "0px 0px 8px 8px",
                            height: "48px",
                            background: Colors.nameBg,
                          }}
                        >
                          <Typography
                            sx={{
                              color: Colors.Tidesfont,
                              fontSize: "20px",
                              fontWeight: 400,
                              fontFamily: "Roboto",
                            }}
                          >
                            Age above 20
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "column" },
          width: "100%",
          justifyContent: "center",
          height: "100%",
          background: Colors.privatePuzle,
          alignItems: "center",
          paddingBottom: { md: "0%", xs: "5%" },
        }}
      >
        <Typography
          sx={{
            color: "#000",
            fontWeight: "bold",
            fontSize: { md: "48px", xs: "24px" },
            fontFamily: "Boogaloo",
            paddingTop: { md: "0%", xs: "5%" },
          }}
        >
          Private Puzzle
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: { md: "5%", xs: "20px" },
            maxWidth: "90%",
            maxHeight: "90%",
            paddingBottom: { md: "2.5%", xs: "5%" },
            paddingTop: { md: "0%", xs: "5%" },
            width: "100%",
            flexWrap: "wrap", // Ensures items wrap to the next line
            justifyContent: { md: "flex-start", xs: "center" }, // Centers the items
          }}
        >
          <Box sx={{ display: "flex", width: { md: "30%", xs: "90%" } }}>
            {uniqueBackToBench.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  background: Colors.privatepuzzlebg,
                  borderRadius: "8px",
                }}
              >
                {uniqueBackToBench.map((chunk, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      gap: "16px",
                      width: "100%",
                      padding: "64px 32px",
                    }}
                  >
                    {chunk.map((creator) => (
                      <Box
                        key={creator.creator_id}
                        sx={{
                          position: "relative", // To position the starburst
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          borderRadius: "8px",
                          height: { md: "300px", xs: "260px" },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px 0px",
                            width: "100%",
                            borderRadius: "8px 8px 0px 0px",
                            height: "48px",
                            background: Colors.nameBg,
                          }}
                        >
                          <Typography
                            sx={{
                              color: Colors.Tidesfont,
                              fontSize: "20px",
                              fontWeight: 600,
                              fontFamily: "Roboto",
                            }}
                          >
                            Back To Bench
                          </Typography>
                        </Box>

                        <img
                          alt="profile"
                          src={backtobench}
                          onClick={() =>
                            handleCreatorClick(
                              creator.creator_id,
                              "Back To Bench",
                            )
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                            //borderRadius: '8px',
                            objectFit: "cover",
                          }}
                        />

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px 0px",
                            width: "100%",
                            borderRadius: "0px 0px 8px 8px",
                            height: "48px",
                            background: Colors.nameBg,
                          }}
                        >
                          <Typography
                            sx={{
                              color: Colors.Tidesfont,
                              fontSize: "20px",
                              fontWeight: 400,
                              fontFamily: "Roboto",
                            }}
                          >
                            95 Vayattuparamba
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}
          </Box>

          <Box sx={{ display: "flex", width: { md: "30%", xs: "90%" } }}>
            {uniqueTimelessTies.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  background: Colors.privatepuzzlebg,
                  borderRadius: "8px",
                }}
              >
                {uniqueTimelessTies.map((chunk, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      gap: "16px",
                      width: "100%",
                      padding: "64px 32px",
                    }}
                  >
                    {chunk.map((creator) => (
                      <Box
                        key={creator.creator_id}
                        sx={{
                          position: "relative", // To position the starburst
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          borderRadius: "8px",
                          height: { md: "300px", xs: "260px" },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px 0px",
                            width: "100%",
                            borderRadius: "8px 8px 0px 0px",
                            height: "48px",
                            background: Colors.nameBg,
                          }}
                        >
                          <Typography
                            sx={{
                              color: Colors.Tidesfont,
                              fontSize: "20px",
                              fontWeight: 600,
                              fontFamily: "Roboto",
                            }}
                          >
                            Timeless Ties
                          </Typography>
                        </Box>

                        <img
                          alt="profile"
                          src={timeless}
                          onClick={() =>
                            handleCreatorClick(
                              creator.creator_id,
                              "Timeless Ties",
                            )
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                            //borderRadius: '8px',
                            objectFit: "cover",
                          }}
                        />

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "4px 0px",
                            width: "100%",
                            borderRadius: "0px 0px 8px 8px",
                            height: "48px",
                            background: Colors.nameBg,
                          }}
                        >
                          <Typography
                            sx={{
                              color: Colors.Tidesfont,
                              fontSize: "20px",
                              fontWeight: 400,
                              fontFamily: "Roboto",
                            }}
                          >
                            2015 ISAT
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          position: "relative",
          display: "flex",
          gap: "16px",
          flexDirection: "column",
          width: "100%",
          height: { md: "160px", xs: "160px" },
          maxWidth: { xs: "92%", md: "92%" },
          justifyContent: "center",
          alignItems: "center",
          background: Colors.Tidesbg,
          borderRadius: "8px",
          overflow: "hidden",
          marginTop: { xs: "5%", md: "2.5%" },
          borderColor: "#EACABB",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: { md: "16px", xs: "8px" },
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { xs: "12px", md: "14px" },
              lineHeight: "24px",
              color: Colors.Tidesfont,
              textAlign: "center",
              fontFamily: "Roboto",
              padding: "0px 20px",
            }}
          >
            We value your feedback! Please share your thoughts and experiences
            to help us improve the game. If you have any queries, feel free to
            contact us.
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "right",
              alignItems: "right",
              maxWidth: { xs: "92%", md: "60%" },
            }}
          >
            <Button
              onClick={() => {
                window.location.href = "/contact-us";
              }}
              sx={{
                background: Colors.button2,
                color: Colors.button2font,
                width: "120px",
                border: "1px solid ",
                borderColor: Colors.button2Border,
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "12px",
                transition: "background 0.3s, transform 0.3s",
                "&:hover": {
                  background: Colors.button2,
                  transform: "scale(1.05)",
                },
                "&:active": {
                  background: Colors.button2,
                },
              }}
            >
              Get in Touch
            </Button>
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: "100%" }}>
        <Footer />
      </Box>
    </Box>
  );
}

export default Landing;
